import React from 'react';
import DatePicker from 'react-datepicker';
import {Form, Select} from 'semantic-ui-react';
import {WARRANTIES_TYPES} from '../../constants';
import {parseDealers} from '../../../common/util/options';
import {yearFormatPicker} from '../../../common/constants/datesFormat';

const SearchForm = ({
  handleChangeDate,
  dealersOptions,
  handleChange,
  dealer,
  typeTwc,
  year,
}) => {
  const dealers = parseDealers(dealersOptions);

  return (
    <Form>
      <label className="label-group">Parámetros de garantías:</label>
      <Form.Group widths="4">
        <Form.Field
          control={Select}
          options={WARRANTIES_TYPES}
          label="Tipo TWC"
          placeholder="Tipo"
          name="typeTwc"
          value={typeTwc}
          onChange={handleChange}
        />
        <Form.Field
          control={Select}
          search
          className='dealer-selection'
          options={dealers}
          label="Concesionario"
          placeholder="Seleccione Concesionario"
          name="dealer"
          value={dealer}
          required
          error={!dealer}
          onChange={handleChange}
        />
        <Form.Input fluid required label="Año">
          <DatePicker
            placeholderText="Año"
            className="tcc-datepicker"
            showYearPicker
            required
            selected={year}
            dateFormat={yearFormatPicker}
            onChange={(value) => handleChangeDate('year', value)}
            locale="es"
          />
        </Form.Input>
      </Form.Group>
    </Form>
  );
};

export default SearchForm;
